import { render, staticRenderFns } from "./AssemblyPicker.vue?vue&type=template&id=0c8d2134&scoped=true"
import script from "./AssemblyPicker.vue?vue&type=script&lang=js"
export * from "./AssemblyPicker.vue?vue&type=script&lang=js"
import style0 from "./AssemblyPicker.vue?vue&type=style&index=0&id=0c8d2134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d2134",
  null
  
)

export default component.exports